module.exports = __webpack_public_path__ + "static/media/logoCropped.1628fd69.png";